<!-- <div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li>
          <a class="link-effect" [routerLink]="['/inducciones', 'resultados']"
            >Mis Inducciones</a
          >
        </li>
      </ol>
    </div>
  </div>
</div> -->
<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Validación de accesos</h3>
    </div>

    <div class="block-content">
      <div class="col-md-6">
        <div class="form-horizontal">
          <div class="form-group">
            <div class="acceso-title">
              <ng-container *ngIf="model.idEstado !== 1">
                <img src="./assets/img/icon_denegado.png">
                <h3 class="control-label">BLOQUEADO</h3>
              </ng-container>
              <ng-container *ngIf="model.idEstado == 1">
                <img src="./assets/img/icon_aprobado.png">
                <h3 class="control-label">Aprobado</h3>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6" *ngIf="model.nroDocumentoIdentidad !== ''">
        <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-3 control-label"
            >Nro de Documento:</label
          >
          <div class="col-md-5">
            <mat-form-field appearance="outline">
              <mat-label>Nro Documento de Identidad:</mat-label>
              <input matInput type="text" [(ngModel)]="model.nroDocumentoIdentidad" disabled />
            </mat-form-field>
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-3 control-label">Apellido Paterno:</label>
          <div class="col-md-5">
            <mat-form-field appearance="outline">
              <mat-label>Apellido Paterno:</mat-label>
              <input
                matInput
                type="text"
                [(ngModel)]="model.apellidoPaterno"
                disabled
              />
            </mat-form-field>
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-3 control-label">Apellido Materno:</label>
          <div class="col-md-5">
            <mat-form-field appearance="outline">
              <mat-label>Apellido Materno:</mat-label>
              <input
                matInput
                type="text"
                [(ngModel)]="model.apellidoMaterno"
                disabled
              />
            </mat-form-field>
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-3 control-label">Nombres:</label>
          <div class="col-md-5">
            <mat-form-field appearance="outline">
              <mat-label>Nombres:</mat-label>
              <input
                matInput
                type="text"
                [(ngModel)]="model.nombres"
                disabled
              />
            </mat-form-field>
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-3 control-label">Fecha Inicio:</label>
          <div class="col-md-5">
            <mat-form-field appearance="outline">
              <mat-label>Fecha Inicio:</mat-label>
              <input
                matInput
                type="text"
                [ngModel]='model.fechaInicio | date: "dd/MM/yyyy"'
                disabled
              />
            </mat-form-field>
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-3 control-label">Fecha Fin:</label>
          <div class="col-md-5">
            <mat-form-field appearance="outline">
              <mat-label>Fecha Fin:</mat-label>
              <input
                matInput
                type="text"
                [ngModel]='model.fechaFin | date: "dd/MM/yyyy"'
                disabled
              />
            </mat-form-field>
          </div>
        </div>

        <!-- <div class="form-group">
          <label class="col-md-1 control-label">Estado:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Estado:</mat-label>
              <input matInput type="text" [(ngModel)]="model.estado" disabled />
            </mat-form-field>
          </div>
        </div> -->

        
            <div class="form-group">
                <div class="col-sm-5 text-right">                  
                  <a class="btn btn-celeste" mat-raised-button [routerLink]="['/acceso-personal', model.idAccesoPersonal]" >Ver Detalle</a>
                </div>
            </div>
        
            <!-- <div class="form-horizontal pad-25"></div> -->

        </div>
      </div>

    </div>
  </div>
</div>
